import { create } from "zustand";
import { retrieveSupportData, updateSupportData } from "./actions";


type DataStoreProps = {
    loading                : boolean    
    data                   : { [key:string]:any} | null
    retrieveData    : () => void
    updateData             : (data:any) => Promise<void>
    error                  : string  
}

export const useSupportStore = create<DataStoreProps>( (set,getState) => ({
    data: null,
    loading: false,
    error: "",
    retrieveData() {
        set( state => ({loading: true, error: ""}))
        retrieveSupportData()
            .then( data => set( state => ({data:data, loading:false})))
            .catch( err => set(state => ({loading:false, error:err})))
    },
    async updateData(data) {
        try {
            await updateSupportData(data)
            set( state => ({data:data}))
        } catch (error) {
            set( state => ({error:"Failed updating data"}))
        }
    },
}))

